// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import WarrantyExpirationDates from './warranty-expiration-dates';

const WarrantyExpirationDateRangeCriteria = props =>
    <div className='warranty-expiration-date-range-criteria'>
        <WarrantyExpirationDates
            dateRange={props.expirationDate}
            label='EXPIRATION_DATE'
            onDateChange={props.onExpirationDateChange}
        />
    </div>;

WarrantyExpirationDateRangeCriteria.displayName = 'WarrantyExpirationDateRangeCriteria';
WarrantyExpirationDateRangeCriteria.propTypes = {
    expirationDate: PropTypes.instanceOf(DateRange).isRequired,
    onExpirationDateChange: PropTypes.func.isRequired
};

export default WarrantyExpirationDateRangeCriteria;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/components/warranty-expiration-date-range-criteria.js